import templateUrl from './repository-list.html';

export const repositoryListComponent = {
    templateUrl,

    bindings: {
        details: '<',
        pageTitle: '@',
        onAdd: '&',
        onEdit: '&',
        module: '@',
        goBackState: '@'
    },
    controller: class RepositoryListComponent {
        constructor(Constants) {
            'ngInject';

            this.Constants = Constants;
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/app/common/components/repository-list/repository-list.component.js